<template>
  <rect width="28" height="24" rx="3" fill="#323232" />
  <rect x="6" y="9.5" width="16" height="5" rx="2.5" fill="#7C7C7C" />
  <rect x="34" width="28" height="24" rx="3" fill="#323232" />
  <rect x="40" y="9.5" width="16" height="5" rx="2.5" fill="#7C7C7C" />
</template>
